import { render, staticRenderFns } from "./Consult.vue?vue&type=template&id=2eb12b30&scoped=true"
import script from "./Consult.vue?vue&type=script&lang=js"
export * from "./Consult.vue?vue&type=script&lang=js"
import style0 from "./Consult.vue?vue&type=style&index=0&id=2eb12b30&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eb12b30",
  null
  
)

export default component.exports